import * as React from 'react';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './CloseButton.css';

export interface ICloseButtonProps {
  onClick?(): void;
}

export const CloseButton: React.FC<ICloseButtonProps> = ({ onClick }) => {
  return (
    <button className={styles['button']} onClick={onClick} aria-label="Закрыть" type="button">
      <IconActionClose16 color="current_color" />
    </button>
  );
};
